<template>
    <section class="section-padding mt-80">
        <div class="container">
            <h4>{{ $t('Privacy Policy') }}</h4>
            <p class="parrafo"><strong>JLHSOFT TECHNOLOGY</strong> {{ $t('is committed to protecting the privacy of all users who interact with our services. This policy describes how we collect, use and protect your personal information.') }} </p>
            <ol>
                <li class="titulo">{{ $t('Information Collected') }}</li>
                <p class="parrafo">{{ $t('We may collect the following information:') }}</p>
                <ol>
                    <li>
                        <span class="titulo">{{ $t('Personal data:') }}</span> {{ $t('Name, email address, telephone number, postal address.') }}
                    </li>
                    <li><span class="titulo">{{ $t('Browsing data:') }}</span> {{ $t('address, device type, browser used and pages visited.') }}</li>
                    <li>{{ $t('Information related to contracted services.') }}</li>
                </ol>
                <li class="titulo mt-20">{{ $t('Use of Information') }}</li>
                <p class="parrafo">{{ $t('We use your information to:') }}</p>
                <ol>
                    <li>{{ $t('Provide and improve our services.') }}</li>
                    <li>{{ $t('Respond to queries and requests.') }}</li>
                    <li>{{ $t('Send promotional communications (with your consent).') }}</li>
                    <li>{{ $t('Comply with legal and safety requirements.') }}</li>
                </ol>
                <li class="titulo mt-20">{{ $t('Share Information') }}</li>
                <p class="parrafo">{{ $t('We do not share your information with third parties, except in the following cases:') }}</p>
                <ol>
                    <li>{{ $t('Third party service providers who help us operate the business.') }}</li>
                    <li>{{ $t('Compliance with legal obligations.') }}</li>
                </ol>
                <li class="titulo mt-20">{{ $t('Security') }}</li>
                <p class="parrafo">{{ $t('We employ technical and organizational measures to protect your personal information against unauthorized access, misuse or disclosure.') }}</p>
                <li class="titulo mt-20">{{ $t('User Rights') }}</li>
                <p class="parrafo">{{ $t('You have the right to:') }}</p>
                <ol>
                    <li>{{ $t('Access, rectify or delete your personal data.') }}</li>
                    <li>{{ $t('Withdraw your consent at any time.') }}</li>
                    <li>{{ $t('File complaints with competent authorities about the handling of your data.') }}</li>
                </ol>
                <li class="titulo mt-20">{{ $t('Contact') }}</li>
                <p class="parrafo">{{ $t('For any questions or requests related to your personal information, contact us at: support@jlhsoft.com.') }}</p>
            </ol>
        </div>
    </section>
  </template>
  <script>
    export default {
    name: 'PrivacyPilicy',
  };
  </script>
  <style scoped>
  .section-padding h4{
    color: #fff;
    font-size: 25px;
    font-family: 'Poppins', sans-serif;
    font-weight: 600;
    text-align: left;
  }
  .parrafo{
    text-align: justify;
    color: #fff;
  }
  
  ol li{
    color: #fff;
    text-align: left !important;
  }
  
  .titulo{
    color: #fff;
    font-weight: 600;
    text-align: left !important;
  }
  .mt-20{
    margin-top: 20px;
  }
  </style>